import { render } from "./staticmodal.vue?vue&type=template&id=1847eb24"
import script from "./staticmodal.vue?vue&type=script&lang=js"
export * from "./staticmodal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__